function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("rect", {
  width: 298,
  height: 80,
  fill: "#FC0000",
  rx: 10
}), React.createElement("path", {
  fill: "#8A0000",
  d: "M0,56 L298,56 L298,72 C298,77.5228475 293.522847,82 288,82 L10,82 C4.4771525,82 6.76353751e-16,77.5228475 0,72 L0,56 Z"
}), React.createElement("path", {
  fill: "#9D0000",
  fillOpacity: .4,
  d: "M10,0 L55,0 L55,26 L0,26 L0,10 C-6.76353751e-16,4.4771525 4.4771525,1.01453063e-15 10,0 Z"
}), React.createElement("polygon", {
  fill: "#B90000",
  points: "0 26 54.633 26 54.633 21 104.3 21 104.3 11 193.7 11 193.7 21 248.333 21 248.333 26 298 26 298 56 0 56"
}), React.createElement("rect", {
  width: 35,
  height: 15,
  x: 109,
  y: 15,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 41,
  height: 15,
  x: 130,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 50,
  height: 15,
  x: 124,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 41,
  height: 15,
  x: 253,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 41,
  height: 15,
  x: 253,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 41,
  height: 15,
  x: 5,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 41,
  height: 15,
  x: 5,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 100,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 100,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 70,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 70,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 15,
  height: 15,
  x: 50,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 15,
  height: 15,
  x: 50,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 179,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 179,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 209,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 20,
  height: 15,
  x: 209,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 15,
  height: 15,
  x: 234,
  y: 35,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 15,
  height: 15,
  x: 234,
  y: 60,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("rect", {
  width: 35,
  height: 15,
  x: 154,
  y: 15,
  fill: "#000",
  fillOpacity: .5,
  rx: 7.5
}), React.createElement("path", {
  fill: "#9D0000",
  fillOpacity: .4,
  d: "M248,0 L288,0 C293.522847,-1.01453063e-15 298,4.4771525 298,10 L298,26 L248,26 L248,0 Z"
}), React.createElement("rect", {
  width: 55,
  height: 21,
  x: 194,
  fill: "#C30000",
  fillOpacity: .4
}), React.createElement("rect", {
  width: 50,
  height: 21,
  x: 54,
  fill: "#C30000",
  fillOpacity: .4
}), React.createElement("rect", {
  width: 89,
  height: 11,
  x: 104,
  fill: "#FC0000",
  fillOpacity: .4
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: 298,
    height: 198,
    viewBox: "0 0 298 198"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/beastmaker.2e214f94.svg";
export { SvgComponent as ReactComponent };